/* ============
 * Vuex Router Back Button
 * ============
 *
 * Provides ability navigating back and forward along the router history
 *
 * https://github.com/MaximVanhove/vue-router-back-button
 */

import Vue from 'vue'
import { router } from './vue-router';
import VueRouterBackButton from 'vue-router-back-button';

Vue.use(VueRouterBackButton, { router })
